module.exports = __webpack_public_path__ + "img/left.63bc4e5b.svg";